export default __webpack_public_path__ + "e7e60cf348020adfbafb864b33c044c4.png";